import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail } from '../utils';

export interface ScanCodeOption extends Partial<GeneralInvokeOption> {
  onlyFromCamera: boolean;
  scanType: Array<string>;
}

// 扫描二维码
export function scanCode(option?: ScanCodeOption) {
  // 校验scanType合法性
  const validScanType: Array<string> = [
    'barCode',
    'qrCode',
    'datamatrix',
    'pdf417'
  ];
  if (option?.scanType && option.scanType.length > 0) {
    if (!option.scanType.every(item => validScanType.indexOf(item) > -1)) {
      return logErrorAndRunFail(
        APINames.Native.SCAN_CODE,
        option,
        'parameter error:parameter.scanType contains invalid values.'
      );
    }
  }
  const fixedOption = Object.assign(
    {
      onlyFromCamera: false,
      scanType: ['barCode', 'qrCode']
    },
    option
  );
  return MacleJSBridge.beforeInvoke(APINames.Native.SCAN_CODE, fixedOption);
}
